import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faUsers, faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PersonaForm from '../components/persona/PersonaForm';
import PersonaResults from '../components/persona/PersonaResults';
import usePersonaGenerator from '../hooks/usePersonaGenerator';
import { COLORS } from '../constants/theme';
import '../App.css';

const Container = styled.div`
  min-height: 100vh;
  background: ${COLORS.darkBg};
  color: white;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  padding: 6rem 2rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;

const ErrorMessage = styled.div`
  color: ${COLORS.error};
  background: rgba(255, 68, 68, 0.1);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
`;

function AppPage() {
  const { t, i18n } = useTranslation();
  const generator = usePersonaGenerator(t);

  const navLinks = [
    { to: '/', icon: <FontAwesomeIcon icon={faUsers} />, label: t('nav.home'), id: 'app-nav-home-031' },
    { href: '/#features', icon: <FontAwesomeIcon icon={faCog} />, label: t('nav.features'), id: 'app-nav-features-032' },
    { href: '/#how-it-works', icon: <FontAwesomeIcon icon={faMagicWandSparkles} />, label: t('nav.howItWorks'), id: 'app-nav-howitworks-033' }
  ];

  return (
    <Container>
      <Helmet>
        <title>Generate Personas | Buyer PersonaX</title>
        <meta name="description" content="Generate detailed buyer personas from your social media followers" />
      </Helmet>

      <Navbar
        links={navLinks}
        showLanguageToggle
        currentLang={i18n.language}
        onLanguageChange={(lng) => i18n.changeLanguage(lng)}
      />

      <Main>
        <PersonaForm
          account={generator.account}
          numPersonas={generator.numPersonas}
          platform={generator.platform}
          surveyFile={generator.surveyFile}
          loading={generator.loading}
          onAccountChange={generator.setAccount}
          onNumPersonasChange={generator.setNumPersonas}
          onPlatformChange={generator.setPlatform}
          onSurveyFileChange={generator.setSurveyFile}
          onSubmit={generator.handleSubmit}
        />

        {generator.error && <ErrorMessage>{generator.error}</ErrorMessage>}

        <PersonaResults result={generator.result} personas={generator.personas} />
      </Main>

      <Footer />
    </Container>
  );
}

export default AppPage;
